import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const ModalContext = createContext(null);

export function ModalProvider({ children }) {
  const [stack, setStack] = useState([]);

  const openModal = useCallback((type, props = {}) => {
    setStack((prev) => [...prev, { id: `${type}_${Date.now()}_${Math.random()}`, type, props }]);
  }, []);

  const closeModal = useCallback(() => {
    setStack((prev) => prev.slice(0, -1));
  }, []);

  const closeAll = useCallback(() => setStack([]), []);

  const replaceModal = useCallback((type, props = {}) => {
    setStack((prev) => {
      if (!prev.length) return [{ id: `${type}_${Date.now()}_${Math.random()}`, type, props }];
      return [...prev.slice(0, -1), { id: `${type}_${Date.now()}_${Math.random()}`, type, props }];
    });
  }, []);

  const value = useMemo(
    () => ({
      stack,
      active: stack[stack.length - 1] || null,
      openModal,
      closeModal,
      closeAll,
      replaceModal,
    }),
    [stack, openModal, closeModal, closeAll, replaceModal],
  );

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
}

export function useModal() {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error("useModal must be used within ModalProvider");
  return ctx;
}

